import { Provider, Type } from '@angular/core';

export abstract class ChatConfigService {
  abstract get chatApiUrl(): string;
}

export function provideChatConfigService(provider: Type<ChatConfigService>): Provider {
  return {
    provide: ChatConfigService,
    useClass: provider,
  };
}
